import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import App from "./App.vue";
import router from "./router";
import { store } from "./store.js";
const fb = require("./firebaseConfig.js");

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

import Moment from "vue-moment";

import moment from "moment";
import vuetify from "./plugins/vuetify";
moment.locale("en-CA");

import { ROLES, RULES } from "./globals";

Vue.use(VueMaterial);
Vue.use(Moment);

Vue.config.productionTip = false;

Vue.prototype.$version = process.env.VUE_APP_VERSION;
Vue.prototype.$roles = ROLES;
Vue.prototype.$rules = RULES;

let app;

fb.auth.onAuthStateChanged(user => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }

  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserRole");

    store.dispatch("fetchInitialData");
  }
});

export const EventBus = new Vue({
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  },
  beforeDestroy() {
    firebase
      .database()
      .ref("/Studies/")
      .off();
    firebase
      .database()
      .ref("/Parameters/")
      .off();
  }
});
